import { Component, Input } from '@angular/core';

@Component({
  selector: 'ct-checked-indicator',
  templateUrl: './checked-indicator.component.html'
})
export class CheckedIndicatorComponent {
  @Input()
  indicator = '';

  public getClass() {
    return this.indicator === 'Y'
      ? 'fa fa-check-square-o fa-lg'
      : 'fa fa-square-o fa-lg';
  }
}
